<template>
  <v-autocomplete
      :items="items"
      item-value="title"
      item-text="title"
      no-data-text="Žiadne výsledky"
      :loading="loading"
      :disabled="loading"
      v-bind="$attrs"
      v-on="$listeners"
  >
    <template
        v-slot:append-outer
    >
      <v-btn
          :small="true"
          :icon="true"
          :outlined="true"
          :loading="loading"
          :disabled="loading"
          @click="init"
      >
        <v-icon>
          mdi-refresh
        </v-icon>
      </v-btn>
    </template>
  </v-autocomplete>
</template>

<script>
  import Indexes from '@/services/indexes'

  export default {
    name: 'Suggest',
    props: [
      'support',
      'module'
    ],
    data() {
      return {
        loading: false,
        indexes: []
      }
    },
    mounted() {
      this.init()
    },
    computed: {
      items() {
        return (
          typeof this.support === 'function'
            ? this.support(this.indexes)
            : this.indexes
        )
      }
    },
    methods: {
      init() {
        this.loadData()
      },
      loadData() {
        this.loading = true

        Indexes
          .suggestModule({
            module: this.module
          })
          .then((response) => {
            this.indexes = response.data.data.indexes
          })
          .catch((error) => {
            switch (error.response.status) {
              case 401:
              case 500:
                this.$store.dispatch('layout/openSnackbar', {
                  message: error.response.data.message
                })

                break
            }
          })
          .finally(() => {
            this.loading = false
          })
      }
    }
  }
</script>
